import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { FB_CONFIG } from "../firebaseConfig.generated";


const app = initializeApp(FB_CONFIG);

export async function registerPushToken(clerkSessionToken) {
    try {
        if (!("Notification" in window)) return;

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const messaging = getMessaging(app);

        // Unregister conflicting service-worker.js, then register FCM worker
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        await navigator.serviceWorker.ready;

        const fcmToken = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration,
        });

        if (!fcmToken) return;
        const deviceId = localStorage.getItem("push_device_id");
        if (!deviceId) return;
        await fetch(`${process.env.REACT_APP_API_URL}/notifications/devices`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${clerkSessionToken}`,
            },
            body: JSON.stringify({
                fcm_token: fcmToken,
                platform: "web",
                device_id: deviceId, // stable UUID in localStorage
                user_agent: navigator.userAgent,
            }),
        });
    } catch (err) {
        // Localhost/dev often 403s on Firebase Installations; push must not block the app.
        console.warn("Push registration skipped:", err?.message || err);
    }
}

export async function unregisterPushToken(clerkSessionToken) {
    const deviceId = localStorage.getItem("push_device_id");
    if (!deviceId) return;

    await fetch(`${process.env.REACT_APP_API_URL}/notifications/devices/${deviceId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${clerkSessionToken}` },
    });
}